var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, IconButton, Switch } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import { useCallback, useState } from 'react';
import { appActions } from 'app/app.actions';
import { analytics } from 'app/utils/segment';
import { ListItemHeader } from 'components/settings/components/sections/openingHours/components/listItemHeader/listItemHeader';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { IntervalsSelect } from '../../../intervalsSelect/intervalsSelect';
import { useListItemContext } from '../../listItem.context';
import styles from '../../listItem.module.scss';
import { OverriddenItem } from '../overriddenItem/overriddenItem';
export const OpeningHours = ({ className, hasConflict, index, itemClassName, openingHours, overrideException, }) => {
    const { duration, id, intervals, name, next_date, opening_hour_type: openingHourType, recurring, } = openingHours;
    const { intervalsSelectProps: { errors, onChange: onIntervalsChange, validate: onIntervalsValidate, }, onDelete, onOverriddenChange, } = useListItemContext();
    const [isClosed, setIsClosed] = useState(!(intervals === null || intervals === void 0 ? void 0 : intervals.length));
    const dispatch = useAppDispatch();
    const handleSwitchChange = useCallback(({ target: { checked } }) => void setIsClosed(!checked), []);
    const handleDeleteClick = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!onDelete)
            return;
        const { isConfirmed, isCancelled } = yield dispatch(appActions.showModal({
            modal: {
                type: 'app:confirm',
                arg: {
                    title: 'Delete exception?',
                    description: `Are you sure want to delete the exception "${name}"`,
                    confirm: {
                        variant: 'danger',
                        label: 'Delete',
                    },
                },
            },
        }));
        if (isConfirmed) {
            onDelete(id)();
            analytics.businessHoursScheduleDeleteExceptionFormSubmitted();
        }
        else if (isCancelled) {
            analytics.businessHoursScheduleDeleteExceptionFormCancelled();
        }
    }), [id, name, dispatch, onDelete]);
    return (_jsxs("div", Object.assign({ className: classNames(styles.root, className) }, { children: [overrideException && onOverriddenChange ? (_jsx(OverriddenItem, { openingHours: openingHours, overrideException: overrideException, onChange: () => onOverriddenChange(openingHours) })) : (_jsxs("div", Object.assign({ className: classNames(styles.item, styles.itemStandard, {
                    [styles.itemIsRegular]: openingHourType === 'regular',
                    [styles.itemIsClosed]: isClosed,
                    [styles.itemHasConflict]: hasConflict,
                }, itemClassName) }, { children: [_jsx(ListItemHeader, { duration: duration, hasConflict: hasConflict, name: name, nextDate: next_date, openingHourType: openingHourType, recurring: recurring }), _jsx(Box, Object.assign({ className: styles.timeRanges }, { children: _jsx(IntervalsSelect, { errors: errors[index] || [], intervals: intervals, isClosed: isClosed, onChange: onIntervalsChange(id), validate: onIntervalsValidate(index) }) })), _jsx(Box, { children: _jsx(Switch, { checked: !isClosed, className: styles.switch, name: "open-switch", value: "", onChange: handleSwitchChange }) })] }))), openingHourType !== 'regular' && onDelete && (_jsx("div", Object.assign({ className: styles.iconButtonWrapper }, { children: _jsx(IconButton, { icon: "trash", onClick: () => {
                        analytics.businessHoursScheduleExceptionOptionsMenuOptionDeleteClicked({ openingHourType });
                        handleDeleteClick();
                    }, variant: "tertiary" }) })))] })));
};
